import { Link } from "react-router-dom";
import { brand } from "../content/site";

const Footer = () => (
  <footer className="bg-eucalyptus text-cream" data-testid="site-footer">
    <div className="max-w-6xl mx-auto px-6 md:px-10 py-14 md:py-20">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-6">
          <p className="font-serif text-2xl">{brand.name}</p>
          <p className="mt-3 text-cream/80 text-sm italic font-serif">{brand.tagline}</p>
          {brand.location && (
            <p className="mt-6 text-cream/70 text-sm">Based in {brand.location}, Australia.</p>
          )}
          <img
            src="/logo-white.webp"
            alt=""
            aria-hidden="true"
            className="mt-10 ml-5 md:ml-8 h-24 md:h-32 w-auto opacity-90"
            data-testid="footer-logo"
          />
        </div>
        <nav aria-label="Footer navigation" className="md:col-span-3">
          <p className="text-xs uppercase tracking-[0.15em] text-cream/60 mb-4">Pages</p>
          <ul className="space-y-2 text-sm">
            <li><Link to="/" data-testid="footer-home-link" className="hover:text-ochre transition-colors duration-300">Home</Link></li>
            <li><Link to="/our-work" data-testid="footer-our-work-link" className="hover:text-ochre transition-colors duration-300">Our Work</Link></li>
            <li><Link to="/funding" data-testid="footer-funding-link" className="hover:text-ochre transition-colors duration-300">Funding &amp; Partnerships</Link></li>
            <li><Link to="/capital-partners" data-testid="footer-capital-partners-link" className="hover:text-ochre transition-colors duration-300">Capital Partners</Link></li>
            <li><Link to="/approach" data-testid="footer-approach-link" className="hover:text-ochre transition-colors duration-300">Approach</Link></li>
            <li><Link to="/about" data-testid="footer-about-link" className="hover:text-ochre transition-colors duration-300">About</Link></li>
            <li><Link to="/resources" data-testid="footer-resources-link" className="hover:text-ochre transition-colors duration-300">Resources</Link></li>
            <li><Link to="/contact" data-testid="footer-contact-link" className="hover:text-ochre transition-colors duration-300">Contact</Link></li>
          </ul>
        </nav>
        <div className="md:col-span-3">
          <p className="text-xs uppercase tracking-[0.15em] text-cream/60 mb-4">Enquiries</p>
          <p className="text-sm text-cream/80 leading-relaxed">
            The best way to reach us is through{" "}
            <Link to="/contact" data-testid="footer-enquiry-link" className="underline decoration-ochre underline-offset-4 hover:text-ochre transition-colors duration-300">
              the contact form
            </Link>
            . We read every enquiry and reply personally.
          </p>
        </div>
      </div>
      <div className="mt-14 pt-6 border-t border-cream/20 flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-cream/60">
        <p>© {new Date().getFullYear()} {brand.name}. All rights reserved.</p>
        <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-ochre transition-colors duration-300">
          Privacy
        </Link>
      </div>
    </div>
  </footer>
);

export default Footer;
